import { useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import api, { storeTokens } from "../lib/api";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { refreshUser } = useAuth();

  const processSession = useCallback(async () => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    try {
      const { data } = await api.get(`/auth/session?session_id=${sessionId}`);
      if (data.access_token) storeTokens(data.access_token, data.refresh_token);
      window.location.hash = "";
      await refreshUser();
      navigate("/dashboard", { replace: true });
    } catch {
      navigate("/login", { replace: true });
    }
  }, [navigate, refreshUser]);

  useEffect(() => {
    processSession();
  }, [processSession]);

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-rose-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-zinc-400 font-body text-sm">Signing you in...</p>
      </div>
    </div>
  );
}
